import { z } from 'zod';
import { paginationMetaSchema } from '@/api/pagination';

export const assignedInstituteItemSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  instituteTypeName: z.string().nullable(),
  thana: z
    .object({
      id: z.coerce.number(),
      name: z.string(),
    })
    .nullable(),
  district: z
    .object({
      id: z.coerce.number(),
      name: z.string(),
    })
    .nullable(),
});

export type AssignedInstituteItem = z.infer<typeof assignedInstituteItemSchema>;

export const paginatedAssignedInstitutesSchema = z.object({
  data: z.array(assignedInstituteItemSchema),
  meta: paginationMetaSchema,
});

export type PaginatedAssignedInstitutes = z.infer<typeof paginatedAssignedInstitutesSchema>;

export interface AssignedInstitutesParams {
  userId: number;
  instituteTypeId?: number | undefined;
  divisionId?: number | undefined;
  districtId?: number | undefined;
  thanaId?: number | undefined;
  instituteId?: number | undefined;
  eiinNumber?: string | undefined;
  name?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export type UnassignedInstituteItem = AssignedInstituteItem;

export const paginatedUnassignedInstitutesSchema = paginatedAssignedInstitutesSchema;

export type PaginatedUnassignedInstitutes = PaginatedAssignedInstitutes;

export type UnassignedInstitutesParams = AssignedInstitutesParams;

export interface AssignInstitutesPayload {
  userId: number;
  instituteIds: number[];
}

export interface RemoveInstitutesPayload {
  userId: number;
  instituteIds: number[];
}
